import { useContext } from 'react';

import { useUtils } from '@ezbobdev/ui-commons';
import { MainContext } from '@ezbobdev/ui-framework';

export const useMobile = (props, widgetName = 'Mobile') => {
  const { name } = props;
  const { actions } = useContext(MainContext);
  const { getConfig, configByName } = useUtils(props, widgetName);

  const value = actions.case.getCaseValue(name);
  const countryCode = actions.settings.getUserConfigProp('locals.countryCode').toLowerCase();
  const phoneMask = actions.settings.getUserConfigProp('locals.phoneMask').toLowerCase();
  const enableCountrySelection = getConfig('enableCountrySelection', false);
  const onlyCountries = enableCountrySelection ? undefined : [countryCode];
  const preferredCountries = [countryCode];
  const countryCodeEditable = getConfig('countryCodeEditable', false);
  const disableCountryCode = getConfig('disableCountryCode', false);
  const disableVerification = getConfig('disableVerification', false);
  const displayInitialValueAsLocalNumber = getConfig('displayInitialValueAsLocalNumber', false);
  const disableDropdown = getConfig('disableDropdown', true);
  const disableAreaCodes = getConfig('disableAreaCodes', true);
  const enableLongNumbers = getConfig('enableLongNumbers', false);
  const forceLtr = getConfig('forceLtr', false);
  const required = actions.caseValidation.isRequired(configByName);

  return {
    ...props,
    value,
    countryCode,
    onlyCountries,
    disableVerification,
    displayInitialValueAsLocalNumber,
    disableDropdown,
    disableAreaCodes,
    enableLongNumbers,
    forceLtr,
    preferredCountries,
    configByName,
    phoneMask,
    countryCodeEditable,
    disableCountryCode,
    required,
  };
};
